import { Link, createFileRoute, useRouter } from '@tanstack/react-router'
import { Button, Card, Form, Input, message } from 'antd'
import { useAdminRegister } from '../hooks/useAdminRegister'
import { useIsSuperuser } from '../hooks/useUserRoles'

export const Route = createFileRoute('/adminRegister')({
  component: AdminRegister,
})

function AdminRegister() {
  const router = useRouter()
  const { isSuperuser, isLoading } = useIsSuperuser()
  const adminRegisterMutation = useAdminRegister()

  const [form] = Form.useForm()

  // 如果不是超级管理员，显示无权限页面
  if (!isLoading && !isSuperuser) {
    return (
      <div style={{ padding: '24px', textAlign: 'center' }}>
        <Card
          title="无权限访问"
          style={{ maxWidth: '400px', margin: '0 auto' }}
        >
          <p>您没有访问此页面的权限，请联系超级管理员。</p>
          <Button type="primary" onClick={() => router.back()}>
            返回上一页
          </Button>
        </Card>
      </div>
    )
  }

  const handleSubmit = async (values: {
    username: string
    password: string
  }) => {
    try {
      await adminRegisterMutation.mutateAsync(values)
      form.resetFields()
      message.success('管理员注册成功！')
    } catch (error) {
      // Error is handled by the mutation
    }
  }

  return (
    <div style={{ padding: '24px' }}>
      <Card title="注册管理员" style={{ maxWidth: '500px', margin: '0 auto' }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item
            label="用户名"
            name="username"
            rules={[
              { required: true, message: '请输入用户名' },
              { min: 3, message: '用户名至少3个字符' },
              { max: 20, message: '用户名最多20个字符' },
            ]}
          >
            <Input placeholder="请输入管理员用户名" />
          </Form.Item>

          <Form.Item
            label="密码"
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6个字符' },
              { max: 20, message: '密码最多20个字符' },
            ]}
          >
            <Input.Password placeholder="请输入管理员密码" />
          </Form.Item>

          <Form.Item
            label="确认密码"
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              { required: true, message: '请确认密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'))
                },
              }),
            ]}
          >
            <Input.Password placeholder="请再次输入密码" />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={adminRegisterMutation.isPending}
              style={{ marginRight: '8px' }}
            >
              注册管理员
            </Button>
            <Button onClick={() => router.back()}>取消</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}
